module.exports = "/images/tg.svg?a8659688bf4b6144bae33a982609b569";